import React from 'react';
import './BusinessList.styles.scss'; // uses .filter-controls and select styles

export default function FilterControls({
  showNoWebsite,
  onToggleNoWebsite,
  showWardFilter,
  onToggleWardFilter,
  wards,
  selectedWard,
  onSelectWard,
  sortOrder,      // ← new
  onSortChange    // ← new
}) {
  return (
    <div className="filter-controls">
      <label>
        <input
          type="checkbox"
          checked={showNoWebsite}
          onChange={onToggleNoWebsite}
        />
        Show businesses without a website
      </label>

      <label>
        <input
          type="checkbox"
          checked={showWardFilter}
          onChange={onToggleWardFilter}
        />
        Filter by ward
      </label>

      {showWardFilter && (
        <select
          value={selectedWard}
          onChange={e => onSelectWard(e.target.value)}
        >
          <option value="">All wards</option>
          {wards.map(w => (
            <option key={w} value={w}>
              Ward {w}
            </option>
          ))}
        </select>
      )}

      {/* Sort dropdown */}
      <select
        value={sortOrder}
        onChange={e => onSortChange(e.target.value)}
      >
        <option value="">Sort: None</option>
        <option value="asc">Name A–Z</option>
        <option value="desc">Name Z–A</option>
      </select>
    </div>
  );
}
